import React from 'react'
import styled from "styled-components";

const Text = ({ size = "20px", weight = "400", align = "center", format = "uppercase", children, motion = null, mobileText = "", width = "100%", color = "var(--text-color)" }) => {
    return (
        <TextWrap $size={size} $color={color} $weight={weight} $width={width} $format={format} $align={align} {...motion}>{mobileText !== "" ? mobileText : children}</TextWrap>
    )
}

export default Text


const TextWrap = styled.div`  
    text-transform: ${(props) => (props.$format)};
    font-size: ${(props) => (props.$size)};
    font-weight: ${(props) => (props.$weight)};
    text-align: ${(props) => (props.$align)};
    margin-block: 0;
    color: ${(props) => (props.$color)};
    width: ${(props) => (props.$width)};  
`

